import { mesaColorNames } from '@/src/common/theme'
import Svg, { Path, type SvgProps } from 'react-native-svg'

export function Check(props: SvgProps) {
  return (
    <Svg width={25} height={24} viewBox="0 0 25 24" fill="none" {...props}>
      <Path
        d="M20.5 6.94995L10.9142 16.5357C10.1332 17.3168 8.86683 17.3168 8.08579 16.5357L4.5 12.95"
        stroke={props.color ?? mesaColorNames['Acre Turquoise/800 #086762']}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
